import { render, staticRenderFns } from "./PredictionsList.vue?vue&type=template&id=dc0dbf70&scoped=true&"
import script from "./PredictionsList.vue?vue&type=script&lang=js&"
export * from "./PredictionsList.vue?vue&type=script&lang=js&"
import style0 from "./PredictionsList.vue?vue&type=style&index=0&id=dc0dbf70&scoped=true&lang=css&"
import style1 from "./PredictionsList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0dbf70",
  null
  
)

export default component.exports